import Image from 'next/image';
import React from 'react';

// const WeightsSecurityTimeline = () => {
//   // Configuration - fully editable
//   const config = {
//     // Canvas dimensions
//     canvas: {
//       width: 700,
//       height: 170,
//       backgroundColor: 'transparent' // Change if you want a background color
//     },
    
//     // Title configuration
//     title: {
//       text: "Weights security",
//       x: 10,             // Horizontal position
//       y: 0,             // Vertical position
//       fontSize: 20,      // Font size in pixels
//       fontWeight: 'regular',// Font weight
//       color: '#004000'   // Text color
//     },
    
//     // Timeline base configuration
//     timeline: {
//       y: 100,            // Vertical position
//       startX: 20,        // Starting x-coordinate
//       endX: 650,         // Ending x-coordinate
//       height: 2,         // Line thickness
//       color: 'black'     // Line color
//     },
    
//     // Year markers configuration
//     yearMarkers: {
//       tickHeight: 6,     // Height of the tick mark
//       tickWidth: 1,      // Width of the tick mark
//       labelOffset: { x: -10, y: -18 }, // Position offset for labels
//       fontSize: 12,      // Font size for year labels
//       color: 'black',    // Color for tick marks
//       labelColor: '#333' // Color for year labels
//     },
    
//     // Years data - each with position
//     years: [
//       { label: "2025", x: 20 },
//       { label: "2026", x: 220 },
//       { label: "2027", x: 420 },
//       { label: "2028 (racing)", x: 620 }
//     ],
    
//     // Blue WSL entries (top)
//     blueWSLs: [
//       { 
//         label: "OpenBrain\nWSL 2", 
//         x: 55,          // Horizontal position
//         y: 35,           // Vertical position
//         lineWidth: 0,    // Line width
//         color: '#0000aa',// Color for both text and line
//         labelWidth: 80,  // Width of the label area
//         fontSize: 12,     // Font size for the label
//         isFirst: true
//       },
//       { label: "WSL 3", x: 320, y: 55, lineWidth: 1, color: '#0000aa', labelWidth: 80, fontSize: 12 },
//       { label: "WSL 4", x: 480, y: 55, lineWidth: 1, color: '#0000aa', labelWidth: 80, fontSize: 12 },
//       { label: "WSL 5", x: 570, y: 55, lineWidth: 1, color: '#0000aa', labelWidth: 80, fontSize: 12 }
//     ],
    
//     // Red WSL entries (bottom)
//     redWSLs: [
//       { 
//         label: "WSL 0\nDeepCent", 
//         x: 55,           // Horizontal position
//         y: 120,          // Vertical position
//         lineHeight: 20,  // Height of the vertical line
//         lineWidth: 0,    // Width of the line
//         color: '#aa0000',// Color for both text and line
//         labelWidth: 80,  // Width of the label area
//         fontSize: 12,     // Font size for the label
//         isFirst: true
//       },
//       { label: "WSL 1", x: 190, y: 120, lineHeight: 20, lineWidth: 1, color: '#aa0000', labelWidth: 80, fontSize: 12 },
//       { label: "WSL 2", x: 290, y: 120, lineHeight: 20, lineWidth: 1, color: '#aa0000', labelWidth: 80, fontSize: 12 },
//       { label: "WSL 3", x: 380, y: 120, lineHeight: 20, lineWidth: 1, color: '#aa0000', labelWidth: 80, fontSize: 12 },
//       { label: "WSL 4", x: 500, y: 120, lineHeight: 20, lineWidth: 1, color: '#aa0000', labelWidth: 80, fontSize: 12 },
//       { label: "WSL 5", x: 580, y: 120, lineHeight: 20, lineWidth: 1, color: '#aa0000', labelWidth: 80, fontSize: 12 }
//     ]
//   };

//   return (
//     <div 
//       className="relative font-mono" 
//       style={{ 
//         width: config.canvas.width, 
//         height: config.canvas.height,
//         backgroundColor: config.canvas.backgroundColor,
//         overflowX: 'scroll',
//         maxWidth: '100%'
//       }}
//     >
//       {/* Title */}
//       <div 
//         className="absolute"
//         style={{ 
//           left: config.title.x, 
//           top: config.title.y,
//           fontSize: `${config.title.fontSize}px`,
//           fontWeight: config.title.fontWeight,
//           color: config.title.color
//         }}
//       >
//         {config.title.text}
//       </div>
      
//       {/* Main horizontal timeline */}
//       <div 
//         className="absolute" 
//         style={{ 
//           left: config.timeline.startX, 
//           top: config.timeline.y, 
//           width: config.timeline.endX - config.timeline.startX, 
//           height: config.timeline.height,
//           backgroundColor: config.timeline.color
//         }}
//       ></div>
      
//       {/* Year markers */}
//       {config.years.map((year, i) => (
//         <div key={`year-${i}`} className="absolute" style={{ left: year.x, top: config.timeline.y-5 }}>
//           {/* Year tick mark */}
//           <div 
//             className="absolute" 
//             style={{ 
//               left: 0, 
//               top: 0, 
//               width: config.yearMarkers.tickWidth, 
//               height: config.yearMarkers.tickHeight,
//               backgroundColor: config.yearMarkers.color
//             }}
//           ></div>
          
//           {/* Year label */}
//           <pre 
//             className="absolute" 
//             style={{ 
//               left: config.yearMarkers.labelOffset.x-5, 
//               top: config.yearMarkers.labelOffset.y,
//               fontSize: `${config.yearMarkers.fontSize}px`,
//               color: config.yearMarkers.labelColor
//             }}
//           >{year.label}</pre>
//         </div>
//       ))}
      
//       {/* Blue WSL markers (top) */}
//       {config.blueWSLs.map((wsl, i) => (
//         <div key={`blue-${i}`} className="absolute" style={{ left: wsl.x, top: wsl.y }}>
//           {/* Text label */}
//           <pre 
//             className="absolute whitespace-pre text-center" 
//             style={{ 
//               color: wsl.color, 
//               left: -(wsl.labelWidth/2), 
//               top: 0, 
//               width: wsl.labelWidth,
//               fontSize: `${wsl.fontSize}px`,
//               textAlign: wsl.isFirst ? 'left' : 'center'
//             }}
//           >{wsl.label}</pre>
          
//           {/* Vertical line */}
//           <div 
//             className="absolute" 
//             style={{ 
//               backgroundColor: wsl.color, 
//               left: 0, 
//               top: wsl.fontSize * (wsl.label.split('\n').length + 1), // Adjust based on label height
//               width: wsl.lineWidth, 
//               height: config.timeline.y - wsl.y - (wsl.fontSize * (wsl.label.split('\n').length + 1))
//             }}
//           ></div>
//         </div>
//       ))}
      
//       {/* Red WSL markers (bottom) */}
//       {config.redWSLs.map((wsl, i) => (
//         <div key={`red-${i}`} className="absolute" style={{ left: wsl.x, top: wsl.y }}>
//           {/* Vertical line */}
//           <div 
//             className="absolute" 
//             style={{ 
//               backgroundColor: wsl.color, 
//               left: 0, 
//               top: -wsl.lineHeight, 
//               width: wsl.lineWidth, 
//               height: wsl.lineHeight
//             }}
//           ></div>
          
//           {/* Text label */}
//           <pre 
//             className="absolute whitespace-pre text-center" 
//             style={{ 
//               color: wsl.color, 
//               left: -(wsl.labelWidth/2), 
//               top: 0, 
//               width: wsl.labelWidth,
//               fontSize: `${wsl.fontSize}px`,
//               textAlign: wsl.isFirst ? 'left' : 'center'
//             }}
//           >{wsl.label}</pre>
//         </div>
//       ))}
//     </div>
//   );
// };

const WeightsSecurityTimeline = () => {
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img src="/weights-security-timeline.png" alt="Weights security timeline" className="w-[100%] h-[100%]" />
  )
}

export default WeightsSecurityTimeline;